import React from "react";
import { useReports, useReportWriter } from "../../projectManagementQueries";
import { LSDBCoreTable } from "../../../common/LSDBCoreTable";
import { Button, FormControl, Grid, LinearProgress, TextField, Typography, Link as MuiLink } from "@material-ui/core";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { generalFilter } from "../../../../util/filter";
import { useDownloadProjectFile } from "../../projectQueries";
import { useHistory } from "react-router";
import { ThreadedCreator } from "../../../common/threadedViewer/threadedCreator";
import { TechWriterDate } from "./TechWriterDate";
import { NoteViewer } from "./NoteViewer";
import { ReportNotes } from "./ReportNotes";
import { Pagination } from "@material-ui/lab";
import { ReportWriterTable } from "./ReportTableWriter";
import { useQueryClient } from "react-query";
import { MovedApproverData } from "./MovedApproverData";
import { useWriterHistory } from "../../../common/CommonQueries";
import moment from "moment";
import { urls } from "../../../common/urls";
import { useFetchContext } from "../../../common/FetchContext";
import { toast } from "react-toastify";

const ReportWritersAgenda = () => {




  const [page, setPage] = React.useState(1);
  const itemsPerPage = 10;
  const [reportNotesMap, setReportNotesMap] = React.useState<{ [key: number]: any[] }>({});
  const [ReportType, setReportType] = React.useState("");
  const [projectNumber, setProjectNumber] = React.useState('');
  const [customer, setCustomer] = React.useState('');
  const [ReportWriter, setReportWriter] = React.useState('');
  const [action, setAction] = React.useState(1);

  const [showApprover, setShowApprover] = React.useState(false);

  const queryClient = useQueryClient();
  const { authAxios } = useFetchContext();
  const history = useHistory();

  const {
    data: writerdata,
    isLoading: isLoadingWriterReports,
    isError,
    error,
    refetch,
  } = useReportWriter(page == 1 ? 0 : (page - 1) * 10, itemsPerPage, action);

  const {
    data: approverData,
    isLoading: isLoadingApproverData,
    isError: isApproverError,
    refetch: refetchApproverData,
  } = useWriterHistory(showApprover);


  if (isLoadingWriterReports) {
    return <LinearProgress />;
  }



  const getDownloads = async (): Promise<any> => {
    if (writerdata.count > 0) {
      const response = await authAxios.get(urls.reportWriterAgenda.writer_report_download, {
        responseType: 'blob'
      });



      const downloadUrl = URL.createObjectURL(response.data);
      let a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `${moment().format("MMM-DD-YYYY-HHMMSS")}`;
      document.body.appendChild(a);
      a.click();
    } else {
      toast.warning("No data found to download")
    }
  };


  const handleApproverdata = () => {
    setShowApprover(prev => !prev);
  }


  return (
    <>
      <Typography variant="h2">Report Writer's Agenda</Typography>

      <div style={{ margin: 10, padding: 10 }}>

        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          spacing={1}
        >


          <Grid item xs={12} alignItems="center" justifyContent="center">

            <Grid container alignItems="center" spacing={1} style={{ marginTop: '10px' }}>
              <Grid item>
                <Typography variant="body1">Download Writer Report:</Typography>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={getDownloads}
                >
                  Download
                </Button>
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    history.push(
                      `/reports/pre_writers_queue/`
                    )
                  }
                >
                  View Pre Writer's Queue
                </Button>
              </Grid>
            </Grid>



          </Grid>

        </Grid>


      </div>
      <Grid item xs={12} style={{ marginBottom: "20px" }}>
        <Pagination
          count={Math.ceil(writerdata.count / itemsPerPage)}
          page={page}
          onChange={(event, value) => {
            console.log('Changing page to:', value);
            setPage(value);
            queryClient.invalidateQueries(['Writer_data']);
          }}
          variant="outlined"
          color="primary"
        />
      </Grid>


      {writerdata && (
        <ReportWriterTable data={writerdata.results} refetch={refetch} />
      )}

      <Grid item xs={12} style={{ marginTop: "20px" }}>
        <Pagination
          count={Math.ceil(writerdata.count / itemsPerPage)}
          page={page}
          onChange={(event, value) => {
            console.log('Changing page to:', value);
            setPage(value);
            queryClient.invalidateQueries(['Writer_data']);
          }}
          variant="outlined"
          color="primary"
        />
      </Grid>

      <Grid item xs={12} style={{ marginTop: "20px" }}>

        <MuiLink
          component="button"
          variant="body1"
          onClick={handleApproverdata}
          style={{ marginLeft: '16px', marginTop: '10px' }}
        >
          {showApprover ? "Hide Approver Data" : "Show Approver Data"}
        </MuiLink>
      </Grid>

      {showApprover && (
        <>
          {isLoadingApproverData && <LinearProgress />}
          {isApproverError && <ErrorMessage message="Failed to load Approver Data" />}
          {approverData && <MovedApproverData data={approverData} />}
        </>
      )}



    </>
  );
};

export default ReportWritersAgenda;
